<template>
    <div class="page-block__item-wrapper">
        <administrative-status
            :label="trans('subscriptions.administrative_status')"
            :status="subscription.administrative_status"
        />

        <renewal-date :label="trans('domain.renew-date')" :renewDate="subscription.end_date"/>

        <subscription-period
            :label="trans('domain.period')"
            :period="subscription.period"
            :periodSuffix="trans('domain.period-suffix')"
            :renewable="true"
            :renewLabel="trans('domain.period-button')"
        />
    </div>
</template>

<script>
import { AdministrativeStatus, RenewalDate, SubscriptionPeriod } from 'relapp-technical-management';

export default {
    components: {
        AdministrativeStatus,
        RenewalDate,
        SubscriptionPeriod
    },
    props: {
        domain: {
            type: String,
            required: true
        },
        subscription: {
            type: Object,
            required: true
        }
    }
};
</script>
